import { supportedLanguages } from '../../common/constants/supported-languages';
export function validateLanguage(language) {
    return language && supportedLanguages.includes(language) ? language : 'en';
}
//# sourceMappingURL=validate-language.js.map